import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { environment } from '@environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { CurrentUserService } from '@shared/services';

@Component({
    selector: 'app-menu-profile',
    templateUrl: './menu-profile.component.html',
    styleUrls: ['./menu-profile.component.scss'],
    standalone: true,
    imports: [TranslateModule, NgTemplateOutlet],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuProfileComponent {
    private auth0 = inject(AuthService);
    private currentUserService = inject(CurrentUserService);

    readonly accountOverviewUrl = computed(
        () => `${environment.omAccountOverviewUrl(this.currentUserService.currentUser().id)}`
    );
    readonly bannerSettingsUrl = environment.omBannerSettingsUrl;

    async logout(): Promise<void> {
        const url = `${environment.auth0.logoutUrl}?client_id=${environment.auth0.clientId}&returnTo=${encodeURI(
            environment.auth0.logoutReturnUrl
        )}`;

        await this.auth0.logout({
            openUrl(_url: string) {
                window.location.replace(url);
            },
        });
    }
}
